import React, { Component, Fragment } from "react";

import "react-picky/dist/picky.css";
import axios from "axios";

import Title from "./FileTitle";
import AlertMessages from "../../../AlertMessages";

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Overlay from "../../../Overlay";
import Papa from "papaparse";
import DownloadImage from "./DownloadImage";

class ViewFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
          File_data: this.props.File_data,
          FileName: this.props.FileName,
          FileData:null,
          imageMode:false,
          currentPage: 1,
            isSuccess: false,
            isPending: false,
            apiError: false,
           
            error: null,
            csv_response1:[],
            columns:[],
            showAlertModal: false,
          
    }}

    componentDidMount = (event) => {
      console.log("names12",this.state.File_data,this.state.FileName)
      const fileExtension = this.state.FileName.split('.').pop().toLowerCase();

      if(fileExtension == "csv"){
        var commonConfig = { delimiter: "," };
        this.setState({
          isSuccess: false,
          isPending: true,
          apiError: false,
          message: "File successfully loaded!",
  
       });
  
        Papa.parse(
          this.state.File_data,
          {
            ...commonConfig,
            header: true,
            download: true,
            complete: (result) => {
              this.setState({
                csv_response1: result.data,
                isSuccess: true,
                          isPending: false,
                          apiError: false,
              },()=>{
  
                console.log("Data11", this.state.csv_response1);
                const keyValues = {};
                result.data.forEach((row) => {
                  keyValues[row.Name] = row.Value;
                });
                const columnNames = result.meta.fields;
                          console.log("columnNames", columnNames);
                          const columns = [
                            // Define other columns here if needed
                            // ...
                          
                            // Dynamically create columns based on column names
                            ...columnNames.map((columnName) => ({
                              Header: `${columnName}`,
                              accessor: columnName,
                              filterable: true,
                              sortable: true,
                              width: 150,
                              Cell: (props) => {
                                return (
                                  <div style={{ textAlign: "left",overflowWrap:'break-word',wordBreak:'normal' }}>
                                    <span title={props.original[columnName]}>
                                      {props.original[columnName]}
                                    </span>
                                  </div>
                                );
                              },
                            })),
                          ];
                          this.setState({
                            columns: columns
                          });
                          console.log("columnS", JSON.stringify(columns));
              });
            }
          }
        );
        this.setState({
                  
          showAlertModal: true
      });
      }


      else if(fileExtension == "pdf"){
        axios.get(this.state.File_data, { responseType: 'arraybuffer' })
        .then((response) => {
          // Create a Blob from the response data
          const blob = new Blob([response.data], { type: 'application/pdf' });
          // Convert the Blob to a data URL
          const url = URL.createObjectURL(blob);
          this.setState({ FileData: url });
        })
        .catch((error) => {
          console.error('Error fetching PDF:', error);
        });
      }


      else if(fileExtension == "jpg" || fileExtension == "png" ||fileExtension == "jpeg"){
        
        this.setState({
                  
          imageMode: true
      });
      }
      else{
        this.setState({
          isSuccess: true,
          isPending: false,
          apiError: false,
          message: "Preview is not supported for this file type!",
  
       },()=>{
        this.setState({
                  
          showAlertModal: true
      });
        setTimeout(this.props.backMethod, 3000);
       });
      }
      
    
  }

      
  closeAlertModal = () => {
    this.setState({
        showAlertModal: false,
    });
};
 
    
   
   
    

    render() {
  
      let csv_response1 = (this.state.csv_response1 !== undefined
        && this.state.csv_response1 !== null && this.state.csv_response1 !== "")
        ? this.state.csv_response1 : [];

    let limit = (csv_response1 !== undefined) ? csv_response1.length : 0;
  
    let customCol = [];
    if (limit > 0) {
        customCol = Object.keys(csv_response1[0]);
    }

  
        return (
            <Fragment>
               <b><Title name={"File Name:  "+ this.state.FileName } /> </b>
               
                
           {this.state.FileData && 
                <iframe
                title="PDF Viewer"
                src={this.state.FileData}
                width="100%"
                height="600px"
              />
              }
      
      {/* {this.state.csv_response1 && this.state.columns &&

<ReactTable
data={this.state.csv_response1}
ref={(r) => this.reactTable = r}
//PaginationComponent={Pagination}
noDataText={properties.reactTableNoDataText}
// NoDataComponent={NoDataConst}
minRows={0}
columns={this.state.columns}
defaultPageSize={100}
resizable={true}
pageSizeOptions={[10, 20, 40, 80, 100, limit]}
className="-striped -highlight"
showPaginationBottom
ticketCount={limit}
style={{ backgroundColor: "#fafafa" }}
contentEditable
//defaultFilterMethod={this.filterMethod}
defaultSorted={[
    {
        id: "Step Record Id",
        desc: false
    }
]}
/>


                } */}

                { this.state.imageMode &&

<div >
<DownloadImage
                   chartName = {this.state.chartName}
                   type = {this.props.type}
                   imagePath = {this.state.File_data}
               />
<img src={this.state.File_data} style={{height:"750px"}} alt="Overlay" />
{/* <button onClick={closeOverlay}>Close</button> */}
</div>

                }
             
             <Overlay
                    openOverlay={this.state.showAlertModal}
                    closeOverlay={this.closeAlertModal}
                    className="alertData"
                >
                    <AlertMessages
                        isSucess={this.state.isSuccess}
                        isPending={this.state.isPending}
                        apiError={this.state.apiError}
                        message={this.state.message}
                        showAlert={this.state.showAlertModal}
                        closeAlert={this.closeAlertModal}
                    />
                </Overlay>
      
            </Fragment>

        );
    }
}

export default ViewFile;
